import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { TMfaSessionIssuesFilterOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { getMfaSessionScans } from 'src/apps/mfa/services/MfaSingleSessionService';
import { MFA_SESSION_SCANS } from 'src/common/providers/reactQueryProvider/QueryKeys';

interface IUseMfaSessionScansQueryParams {
	sessionId: string;
	filters?: TMfaSessionIssuesFilterOptions;
}

export const useMfaSessionScansQuery = ({
	sessionId,
	filters
}: IUseMfaSessionScansQueryParams): UseQueryResult<Map<string, string>> => {
	const scansQuery = useQuery(
		[MFA_SESSION_SCANS, sessionId, filters],
		async (): Promise<Map<string, string>> =>
			getMfaSessionScans({
				sessionId,
				filterOptions: filters
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return scansQuery;
};
